import { BaseFilterForm } from '../enums';
import LocationQueryMapper from '../../forms/location/mappers/QueryMapper';
import DatePeriodQueryMapper from '../../forms/date-period/mappers/QueryMapper';

export default class BaseFilterQueryMapper {
  static mapFromQueries(queries) {
    return {
      [BaseFilterForm.Location]: LocationQueryMapper.mapFromQueries(queries),
      [BaseFilterForm.DatePeriod]: DatePeriodQueryMapper.mapFromQueries(queries),
    };
  }

  static mapToQueries(formData) {
    const location = formData[BaseFilterForm.Location];
    const datePeriod = formData[BaseFilterForm.DatePeriod];

    return {
      ...LocationQueryMapper.mapToQueries(location),
      ...DatePeriodQueryMapper.mapToQueries(datePeriod),
    };
  }
}
